import React from 'react'
import StripeCCForm from '~/components/StripeCCForm'
import verifiedImg from './images/verified.png'
import './style.css'

export default class Form extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.fields
    }
  }

  render() {
    return (
      <form
        onSubmit={ e => this.onStripeSubmit(e) }
        className="popup-stripe-cc-form">
        <StripeCCForm
          buttonCaption="Subscribe Now!"
          formRef={ el => this.stripeFormEl = el }
          onReady={ b => this.onStripeReady(b) }
          apiKey={ ((window.settings.paymentProviders || {}).stripe || {}).apiKey }
          fields= {this.state.fields}
          leftContent={(
            <div className="verification-banner">
              <img alt="Verification" src={ verifiedImg } role="presentation" />
            </div>
          )}
          rightContent={ this.stripeButtons() }
          // stripeLoading={ this.state.stripeLoading } 
          {...this.props}
          />
      </form>
    )
  }

  stripeButtons() {
    return (
      <div>
        { this.state.alert && <div className="alert">{ this.state.alert }</div> }
        <input
          className={
            'button continue-button' +
            (this.state.stripeIsReady ? ' cta' : '') +
            (this.state.stripeLoading ? ' disabled' : '')
          }
          type="submit"
          ref={ el => this.submitButton = el }
          value={ this.state.stripeLoading ? '...' : (this.props.submitCaption || 'Continue') } 
        />
      </div>
    )
  }

  onStripeReady(e) {
    this.setState({ stripeIsReady: e })
  }

  onStripeSubmit(e) {
    e.preventDefault()
    this.setState({ stripeLoading: true })
    var stripeObj = this.stripeFormEl.props.stripe;
    this.stripeFormEl
      .createToken()
      .then(p => this.props.onToken(p, stripeObj))
      .catch(e => {
        this.alert(
        (((e || {}).response || {}).data || {}).message || e.message || 
        'There was an error processing your request.'
        );
        this.setState({ stripeLoading: false })
      })
  }

  alert(msg) {
    this.setState({ alert: msg })
    setTimeout( _ => this.setState({ alert: null }), 4000 )
  }
}